import React, { useEffect, useState } from "react";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const useIsMobile = ({ breakpoint = 425 }) => {
  const [width, setWidth] = useState(breakpoint);

  useEffect(() => {
    setWidth(window.innerWidth);

    const handleWindowSizeChange = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return width <= breakpoint;
};

export default useIsMobile;
